var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dividends === true
    ? _c("dividends-page", {
        attrs: { sale: _vm.sale },
        on: {
          "dividends-page-status": function($event) {
            return _vm.setDividendsPage($event)
          }
        }
      })
    : this.sale && this.token
    ? _c("div", { staticClass: "sale-details md-layout md-gutter" }, [
        _c(
          "div",
          { staticClass: "md-layout-item md-size-50 md-small-size-100" },
          [
            _c(
              "div",
              { staticClass: "container sale-details__media text_margin" },
              [
                _vm.sale.youtube_video_id
                  ? _c("div", { staticClass: "sale-details__media-wrap" }, [
                      _c("iframe", {
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          "border-radius": "16px"
                        },
                        attrs: {
                          src: _vm.embedVideoUrl,
                          frameborder: "0",
                          allow:
                            "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: ""
                        }
                      })
                    ])
                  : _vm.sale.image
                  ? _c("div", { staticClass: "sale-details__media-wrap" }, [
                      _c("img", {
                        staticClass: "sale-details__image",
                        attrs: { src: _vm.sale.image, alt: "image" }
                      })
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("sale-tabs", {
              staticClass: "sale-details__tabs",
              attrs: {
                id: "saleTabs",
                sale: _vm.sale,
                description: _vm.description,
                syndicate: _vm.syndicate,
                token: _vm.token,
                curTab: _vm.curTab
              },
              on: {
                "dividends-page-status": function($event) {
                  return _vm.setDividendsPage($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "md-layout-item md-size-50 md-small-size-100" },
          [
            _c(
              "div",
              {
                staticClass:
                  "container container_30 text_margin sale-details__finance"
              },
              [
                _c("div", { staticClass: "finance-header text_x_small" }, [
                  _c(
                    "div",
                    { staticClass: "finance-header__back" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "back-btn",
                          attrs: { to: "/sales/explore" }
                        },
                        [
                          _c("md-icon", {
                            attrs: { "md-src": "/static/img/arrow_back.svg" }
                          }),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.i18n.sale_back_to_list()) +
                              "\n                  "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "finance-header__status" }, [
                    _vm.sale.state === "canceled"
                      ? _c(
                          "span",
                          [
                            _c("md-icon", {
                              attrs: { "md-src": "/static/img/cancel_icon.svg" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sale.state === "closed"
                      ? _c(
                          "span",
                          [
                            _c("md-icon", {
                              attrs: { "md-src": "/static/img/cancel_icon.svg" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.sale.state === "open"
                      ? _c(
                          "span",
                          [
                            _c("md-icon", {
                              attrs: {
                                "md-src": "/static/img/pending_icon.svg"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [
                      _vm.sale.state === "open"
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.sale.daysToEnd === 0
                                  ? _vm.i18n.sale_ends_today()
                                  : _vm.i18n.sale_to_end({
                                      days: _vm.sale.daysToEnd
                                    })
                              ) + " "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(_vm.i18n.com_campaign()) +
                                " " +
                                _vm._s(_vm.saleStatus)
                            )
                          ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "finance__project-info" }, [
                  _c(
                    "div",
                    { staticClass: "finance__project-info-name text_x_large" },
                    [
                      _vm._v(
                        _vm._s(_vm.sale.name) +
                          " (" +
                          _vm._s(_vm.sale.baseAsset) +
                          ")"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "finance__project-info-type text_x_small" },
                    [_vm._v(_vm._s(_vm.saleType))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "finance__card-progress card-progress" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-progress__stats text_small" },
                      [
                        _vm.profitability
                          ? _c(
                              "div",
                              [
                                _c("md-icon", {
                                  attrs: {
                                    "md-src": "/static/img/grow_up_icon.svg"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "text_small" }, [
                                  _vm._v(_vm._s(_vm.profitability))
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("md-icon", {
                              attrs: { "md-src": "/static/img/man_icon.svg" }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "text_small" }, [
                              _vm._v(_vm._s(_vm.sale.investors))
                            ])
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-progress__bar" }, [
                      _c("div", {
                        staticClass: "progress-line",
                        style: "width: " + _vm.progress + "%"
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-progress__amounts" }, [
                      _c(
                        "div",
                        { staticClass: "text_medium text_bold text_active" },
                        [
                          _vm._v(
                            _vm._s(_vm.assetIcon(_vm.sale.defaultQuoteAsset)) +
                              " " +
                              _vm._s(
                                _vm.roundCurrency(
                                  _vm.sale.currentCap,
                                  _vm.sale.defaultQuoteAsset
                                )
                              ) +
                              " "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "text_medium text_bold card__goal-amount"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.assetIcon(_vm.sale.defaultQuoteAsset)) +
                              " " +
                              _vm._s(
                                _vm.roundCurrency(
                                  _vm.sale.hardCap,
                                  _vm.sale.defaultQuoteAsset
                                )
                              )
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "finance__actions" },
                  [
                    _vm.isOwner
                      ? _c(
                          "div",
                          { staticClass: "btn-wrap space-between margin-top" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "btn md-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.tab("Updates")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.i18n.sale_add_update_bt()) +
                                    "\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "btn md-primary",
                                on: {
                                  click: function($event) {
                                    return _vm.tab("Documents")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.i18n.sale_upload_document_bt()) +
                                    "\n                  "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _c("sale-invest", {
                          attrs: { sale: _vm.sale },
                          on: { onChangeCamapignData: _vm.loadDetails }
                        })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container container_30 sale-details__history" },
              [
                _c("sale-chart", {
                  staticClass: "sale-details__information-item",
                  attrs: { sale: _vm.sale }
                })
              ],
              1
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-560dc26e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560dc26e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/sale_details/Sales.Details.vue
// module id = ruxF
// module chunks = 1